import { getAuthHeaders } from './authUtils';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';

class FlowApiService {
  async getConfig(key) {
    const response = await fetch(`${API_BASE_URL}/api/flow-config/${encodeURIComponent(key)}`, {
      headers: getAuthHeaders(),
    });
    if (!response.ok) {
      throw new Error(`Failed to get flow config for ${key}: ${response.status}`);
    }
    return response.json();
  }
  async setEnabled(key, enabled) {
    const response = await fetch(`${API_BASE_URL}/api/flow-config/${encodeURIComponent(key)}/enabled`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify({ enabled })
    });
    if (!response.ok) {
      throw new Error(`Failed to set enabled for ${key}: ${response.status}`);
    }
    return response.json();
  }
  async getWebhookInfo(key) {
    const response = await fetch(`${API_BASE_URL}/api/flow-config/${encodeURIComponent(key)}/webhook`, {
      headers: getAuthHeaders(),
    });
    if (!response.ok) {
      throw new Error(`Failed to get webhook info for ${key}: ${response.status}`);
    }
    return response.json();
  }
}

export const flowApi = new FlowApiService();


